import Model from "~/models/_Model";

export default class Staff extends Model {
  // Define a base url for a REST API
  baseURL() {
    return super.baseURL() + "/leydenmobile";
  }

  // Set the resource route of the model
  resource() {
    return "staff";
  }

  relations() {
    return {
      //student: Student,
    };
  }

  /**
   * Helper Methods
   */

  /**
   * Helper Attributes
   */
  get display_picture_url() {

    if (this.picture_url) {
      // return this.picture_url.replace("//mylhs", "//app-mylhs") + "?appId=1";
    }
    if (this.FMS_EMPL_NUMBER) {
      // return super.baseURL().replace('/api/v2', '/') + `esp/students/image/${this.FMS_EMPL_NUMBER.trim()}?appId=1`;
    }
    // https://app-mylhs.leyden212.org/esp/students/image/20000
    return "/person.jpg";
  }
}
